import React from "react";
import moment from "moment";
// import { useDispatch, useSelector } from "react-redux";
// import { Drawer, Layout, Col, Row } from "antd";

class ElapsedTime extends React.Component {
  state = {
    seconds: 0,
    cTime: "00:00:00",
  };

  componentDidMount = () => {
    this.interval = setInterval(this.updateTime, 1000);
    this.cinterval = setInterval(this.updateCTime, 1000);
  };

  componentWillUnmount = () => {
    clearInterval(this.interval);
    delete this.interval;
    clearInterval(this.cinterval);
    delete this.cinterval;
  };

  updateCTime = () => {
    this.setState({
      cTime: moment().format("HH:mm:ss").toString(),
    });
  };

  updateTime = () => {
    if (this.props.lastTime) {
      this.setState({
        seconds: moment
          .utc()
          .diff(
            moment.utc(this.props.lastTime, "YYYY-MM-DD HH:mm:ss"),
            "seconds"
          ),
      });
    }
  };

  prependZero = (num) => {
    if (num < 10) return "0" + num;
    else return num;
  };

  displayTimeFormat = () => {
    const hour = this.prependZero(Math.floor(this.state.seconds / 3600));
    const min = this.prependZero(Math.floor((this.state.seconds % 3600) / 60));
    const second = this.prependZero((this.state.seconds % 3600) % 60);

    return `${hour}:${min}:${second}`;
  };

  render() {
    return (
      <div
        className="elapsedTime"
        style={{
          display: "flex",
          flexDirection: "column",

          marginRight: "12px",
        }}
      >
        <div
          style={{
            fontWeight: 600,
            fontSize: "18px",
            marginLeft: "2px",
            marginBottom: "5px",
          }}
        >
          {this.props.static ? "Current Time" : "Elapsed Time"}
        </div>
        <div style={{ marginTop: "3px" }}>
          {" "}
          <p
            style={{
              borderRadius: "7px",
              minWidth: "100%",
              color: "#fff",
              textAlign: "center",
              backgroundColor: "#3b3b3b",
              fontSize: "30px",
              paddingTop: "10px",
              paddingBottom: "10px",
              fontWeight: 600,
            }}
          >
            {this.props.static ? this.state.cTime : this.displayTimeFormat()}
          </p>
        </div>
      </div>
    );
  }
}

export default ElapsedTime;
